import { useQuery } from '@tanstack/react-query'
import { analyticsApi } from '../api/client'

export function useAnalyticsSummary(range: number) {
  return useQuery({
    queryKey: ['analytics', 'summary', range],
    queryFn: () => analyticsApi.summary(range),
    staleTime: 60_000,
  })
}

export function useAnalyticsCampaigns(range: number) {
  return useQuery({
    queryKey: ['analytics', 'campaigns', range],
    queryFn: () => analyticsApi.campaigns(range),
    staleTime: 60_000,
  })
}

export function useAnalyticsGeo(range: number) {
  return useQuery({
    queryKey: ['analytics', 'geo', range],
    queryFn: () => analyticsApi.geo(range),
    staleTime: 60_000,
  })
}

export function useAnalyticsUsers(range: number) {
  return useQuery({
    queryKey: ['analytics', 'users', range],
    queryFn: () => analyticsApi.users(range),
    staleTime: 60_000,
  })
}
